export default (data, colIndex, order) => { 
    return data.sort((a, b) => { 
        /*
            SIT = 0
            CD_FIL = 1
            CD_NUM = 2
            NR_PC = 3
            NM_PROD = 4
            CD_ALFA = 5
            AB_COR1 = 6
            QTD = 7
        */
        if (
            colIndex === 1 || colIndex === 2 || colIndex === 3 || colIndex === 7
        ) { 
            return (parseInt(a.data[colIndex]) < parseInt(b.data[colIndex]) ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
        //String ou Outros
        else { 
            return (a.data[colIndex] < b.data[colIndex] ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
    }); 
};